export const isProd = process.env.NODE_ENV === "production";

export function getEnvironment() {
  let env = "development";

  const customEnv = process.env.REACT_APP_ENV || "";
  switch (customEnv) {
    case "production":
      env = "production";
      break;
    case "qa":
      env = "qa";
      break;
    case "staging":
      env = "staging";
      break;
    case "dev":
      env = "dev";
      break;
    default:
      env = process.env.NODE_ENV;
      break;
  }

  console.log({ env });

  return env;
}

export const environment =
  getEnvironment() === "production"
    ? {
        storage: "https://cdn.li.omniflou.com",
        server: "https://api.omniflou.com",
        ws_url: "https://ws.omniflou.com/videolink",
      }
    : getEnvironment() === "qa"
    ? {
        storage: "https://cdn.qa.li.omniflou.com",
        server: "https://api.qa.omniflou.com",
        ws_url: "https://ws.qa.omniflou.com/videolink",
      }
    : getEnvironment() === "staging"
    ? {
        storage: "https://cdn.pre.videolink.app",
        server: "https://api.pre.videolink.app",
        ws_url: "https://ws.pre.videolink.app/videolink",
      }
    : getEnvironment() === "dev"
    ? {
        storage: "https://cdn.dev.li.omniflou.com",
        server: "https://api.dev.omniflou.com",
        ws_url: "https://ws.dev.omniflou.com/videolink",
      }
    : {
        storage: "http://localhost:3003",
        server: "http://localhost:3001",
        ws_url: "http://localhost:3002/videolink",
      };

export const TOKEN_KEY = `agent_token`;

function getServerHost() {
  const apiUrl = environment.server;
  if (apiUrl) {
    return apiUrl;
  } else {
    return isProd
      ? `http://${window.location.host}`
      : `http://${window.location.hostname}:4000`;
  }
}

export const SERVER_HOST = getServerHost();
export const API_BASE_URL = `${SERVER_HOST}`;
//URL
export const maxFileImg = 1048576;
